import { AccountService } from './../../../model/services/api-services/account.service';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';

export type AccountInfo = {
  account_id: string;
  max_subaccounts: string;
  contact_id: string;
  managers_group_id: string,
  max_projects: string;
  expires: string;
}

export type AccountContactInfo = {
  contact_id: string;
  display_name: string;
  account_id: string;
  identity: string;
  created: Date;
  last_login: Date;
}

@Component({
  selector: 'app-org-metadata',
  templateUrl: './org-metadata.component.html',
  styleUrls: ['./org-metadata.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgMetadataComponent implements OnInit {

  private _account?: AccountInfo;
  private _accountContact?: AccountContactInfo;
  private _owner?: boolean;
  private _admin?: boolean;
  private _employee?: boolean;
  private _loaded = false;
  public needsReset: boolean = false;
  constructor(private accountSvc: AccountService, private cdr: ChangeDetectorRef) { }

  private _displayName: string = '';
  public set displayName(name: string) {
    this._displayName = name;
    if (!!this._accountContact) {
      this._accountContact.display_name = this._displayName;
    }
  }
  public get displayName() {
    return this._displayName;
  }

  private _identity: string = '';
  public set identity(id: string) {
    this._identity = id;
    if (this._accountContact) {
      this._accountContact.identity = this._displayName;
    }
  }
  public get identity() {
    return this._identity;
  }

  public get lastLogin(): string {
    if (!this._accountContact) {
      return '';
    }
    const llogin = this._accountContact.last_login;
    if (!llogin) return '';
    return llogin.toLocaleString();
  }
  public get created(): string {
    if (!this._accountContact) {
      return '';
    }
    const created = this._accountContact.created;
    if (!created) return '';
    return created.toLocaleString();
  }

  public get editable(): boolean {
    if (this._admin || this._owner) return true;
    return false;
  }

  private _password: string = '';
  public set password(pw: string) {
    this.password = pw;
  }
  public get password(): string {
    return this._password;
  }

  private _orgId:number = -1;
  @Input() set orgId(v:number) {
    if(this._orgId === v) return;
    this._orgId = v;
    if(this._orgId != -1 ) {
        this.GetInfo();
    }
  }
  get orgId():number {
    return this._orgId;
  }

  ngOnInit(): void {

  }
  GetInfo() {
    this.accountSvc.GetAccount(this.orgId).then((response) => {
      this._account = response.account;
      this._accountContact = response.contact;
      this._displayName = '' + this._accountContact?.display_name;
      this._owner = response.owner === 'true';
      this._admin = response.admin === 'true';
      this._employee = response.admin === 'true';
      this._identity = ''+this._accountContact?.identity;
      this._loaded = true;
      this.Refresh();

    });

  }
  public NeedReset() {
    this.needsReset = true;
    this.Refresh();
  }
  public CancelReset() {
    this.needsReset = false;
    this.Refresh();
  }
  public Refresh() {
    if (this._loaded) {
      this.cdr.detectChanges();
    }
  }
}
